// TEAM_005: Types for tournament prize payout (Reward view after tournament finish).

export type TournamentPrizePayoutStatus = 'PENDING' | 'INITIATED' | 'CONFIRMED' | 'FAILED';

export type TournamentPrizePayoutType = 'WINNER_REWARD' | 'OVERPAYMENT_REFUND' | 'CANCEL_REFUND';

export interface TournamentPrizePayout {
  id: number;
  tournament: number;
  user: number;
  payout_type?: TournamentPrizePayoutType;
  amount: string;
  reward?: number;
  overpayment?: number;
  currency: string;
  status: TournamentPrizePayoutStatus;
  from_address: string | null;
  to_address: string | null;
  tx_hash: string | null;
  confirmations: number | null;
  initiated_at: string | null;
  confirmed_at: string | null;
  attempt_count: number | null;
  last_attempt_at: string | null;
  next_retry_at: string | null;
  error_code: string | null;
  error_message: string | null;
  gas_fee_deducted: string | null;
}

export interface GetTournamentPrizePayoutMeResponse {
  data: TournamentPrizePayout;
}

export const mapPrizePayoutCurrencyLabel = (currency: string | null | undefined): string => {
  if (!currency) {
    return 'POL';
  }

  if (currency === 'MATIC') {
    return 'POL';
  }

  return currency;
};
